import React, { useRef } from 'react';
import { useScrollAnimation } from '../../hooks/useScrollAnimation';

// Import culture images - replace these with your actual images
import cultureDiagram1 from '../../assets/images/cultureDiagram1.png'; // Pink gradient culture diagram
import cultureDiagram2 from '../../assets/images/cultureDiagram2.png'; // Circular culture diagram
import cultureDiagram3 from '../../assets/images/cultureDiagram3.png'; // Green culture diagram

const OurCulture = () => {
  // Create refs for animation targets
  const sectionRef = useRef(null);
  const headingRef = useRef(null);
  const paragraphRef = useRef(null);
  const diagramsContainerRef = useRef(null);
  
  // Use our custom animation hooks
  useScrollAnimation({
    type: "fade",
    scope: sectionRef,
    trigger: "top 80%",
    duration: 0.8,
    from: { y: 40, opacity: 0 },
    to: { y: 0, opacity: 1 },
    ease: "power3.out"
  });
  
  // Staggered animation for culture diagrams
  useScrollAnimation({
    type: "stagger",
    scope: diagramsContainerRef,
    trigger: "top 70%",
    stagger: 0.2,
    duration: 0.8,
    from: { y: 50, opacity: 0 },
    to: { y: 0, opacity: 1 },
    ease: "power2.out"
  });
  return (
    <section ref={sectionRef} className="w-full bg-white py-[60px] md:py-20 overflow-hidden">
      <div className="max-w-[1281px] mx-auto px-4 md:px-6 lg:px-8">
        {/* Main heading and description */}
        <div className="mb-8 md:mb-[40px]">
          <h2 
            ref={headingRef} 
            className="font-[LTWave] font-medium text-3xl md:text-4xl lg:text-[44px] leading-[150%] capitalize mb-4 will-change-transform"
          >
            Our Culture
          </h2>
          <p 
            ref={paragraphRef} 
            className="font-inter font-normal text-base md:text-lg lg:text-[18px] leading-[150%] max-w-[1000px] will-change-transform"
          >
            At Agstya, we foster a collaborative and inclusive environment where every team member's contribution is valued. 
            We believe in continuous learning and growth, providing opportunities for professional development and advancement.
          </p>
        </div>

        {/* Culture diagrams */}
        <div ref={diagramsContainerRef} className="flex flex-col md:flex-row gap-8 lg:gap-[32px] justify-between h-auto md:h-[277px]">
          {/* Culture diagram 1 - pink gradient */}
          <div className="culture-diagram w-full md:w-1/3 rounded-[58px] overflow-hidden bg-gradient-to-r from-pink-400 to-purple-400 h-[200px] md:h-full will-change-transform transition-all duration-300 hover:shadow-lg hover:-translate-y-2">
            <img 
              src={cultureDiagram1} 
              alt="Company Culture Beliefs and Values" 
              className="w-full h-full object-cover transition-transform duration-500 hover:scale-105"
            />
          </div>

          {/* Culture diagram 2 - circular diagram */}
          <div className="culture-diagram w-full md:w-1/3 rounded-[58px] overflow-hidden bg-rose-50 h-[200px] md:h-full will-change-transform transition-all duration-300 hover:shadow-lg hover:-translate-y-2">
            <img 
              src={cultureDiagram2} 
              alt="Types of Company Cultures" 
              className="w-full h-full object-cover transition-transform duration-500 hover:scale-105"
            />
          </div>

          {/* Culture diagram 3 - green diagram */}
          <div className="culture-diagram w-full md:w-1/3 rounded-[58px] overflow-hidden bg-green-500 h-[200px] md:h-full will-change-transform transition-all duration-300 hover:shadow-lg hover:-translate-y-2">
            <img 
              src={cultureDiagram3} 
              alt="Company Culture Framework" 
              className="w-full h-full object-cover transition-transform duration-500 hover:scale-105"
            />
          </div>
        </div>
      </div>
    </section>
  );
};

export default OurCulture;
